module.exports = __webpack_public_path__ + "img/individual_weddingrings_ring_5.88e42ac.jpg";